import { Linkedin } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { EmailCaptureForm } from "./EmailCaptureForm";

export function Footer() {
  return (
    <footer id="contact-footer" className="bg-background text-foreground border-t border-foreground/15 py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-12 md:grid-cols-2 md:items-end">
          <div className="max-w-md">
            <h3 className="font-serif text-2xl tracking-tight">Notes on referrals and visibility</h3>
            <p className="mt-2 text-sm text-muted-foreground">
              Occasional ideas for financial professionals who want to build a referral engine instead of chasing leads.
            </p>
            <div className="mt-5">
              <EmailCaptureForm
                source="footer-newsletter"
                variant="inline"
                buttonLabel="Join the list"
                successMessage="You're in. Look for a note from me soon."
              />
            </div>
          </div>

          <div className="flex flex-col md:items-end gap-6">
            <div className="flex flex-wrap items-baseline gap-x-6 gap-y-2 text-sm">
              <Link to="/" className="text-muted-foreground hover:text-primary transition-colors">Home</Link>
              <Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">Insights</Link>
              <Link to="/headline" className="text-muted-foreground hover:text-primary transition-colors">Free headline fix</Link>
              <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">Contact</Link>
            </div>
            <div className="flex flex-wrap items-baseline gap-x-6 gap-y-2 text-sm text-muted-foreground">
              <a href="mailto:katie@katiefernands.com" className="hover:text-primary transition-colors">
                katie@katiefernands.com
              </a>
              <a href="tel:+16123841217" className="hover:text-primary transition-colors">
                612 384 1217
              </a>
              <span className="text-xs tracking-[0.18em] uppercase">Minneapolis</span>
            </div>
            <div className="flex items-center gap-6 text-muted-foreground">
              <a
                href="https://www.linkedin.com/in/katiefernands/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="hover:text-primary transition-colors"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <span className="text-xs tracking-[0.2em]">© {new Date().getFullYear()} Katie Fernands</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
